import { Provider } from 'react-redux';
import { store, context } from './ThreadViewDataStore';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadDataProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    context: context,
    children: children
  });
};
ThreadDataProvider.displayName = 'ThreadDataProvider';
export default ThreadDataProvider;